<uc-clearing-header [subject]="subject()" />
<!-- @if (faq) {
	<div class="container">
		<div class="border-t">
			<uc-faq-accordion
				[faq]="faq"
				[ugSearchOrderPosition]="null"
				[cleSearchOrderPosition]="null"
			/>
		</div>
	</div>
} -->
